import { clsx } from 'clsx';
import { FC, ReactNode } from 'react';

import { unstable_composeClasses as composeClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

import { shouldForwardProp as sysShouldForwardProp } from '@mui/system';

import Box, { BoxProps } from '../Box';
import { BaseBackgroundColorList } from '../theme/colorList';
import colors from '../theme/colors';
import { getPaperUtilityClass } from './paperClasses';

const useFooterUtilityClasses = () => {
  return composeClasses(
    {
      footer: ['footer'],
    },
    getPaperUtilityClass,
    undefined
  );
};

export interface FooterProps extends BoxProps {
  /**
   * Background color, only two variants ('default' - the default, and 'internal').
   * @default 'default'
   */
  color?: BaseBackgroundColorList;

  children: ReactNode;
}

const StyledBox = styled(Box, {
  name: 'O2Paper',
  slot: 'Footer',
  shouldForwardProp: (prop) => sysShouldForwardProp(prop) && prop !== 'color',
})(({ color, theme }) => ({
  background:
    color === 'internal'
      ? theme.palette.background.internalDark
      : `linear-gradient(${colors.transparentWhite[500]}, ${colors.transparentWhite[500]}), ${theme.palette.background.default}`,
  margin: '-1px',
}));

export const defaultFooterPaddings = {
  xl: 4,
  sm: 3,
  xs: 2,
};

const Footer: FC<FooterProps> = ({ color = 'default', children, p = defaultFooterPaddings, ...props }) => {
  const classes = useFooterUtilityClasses();

  return (
    <StyledBox color={color} p={p} {...props} className={clsx(classes.footer)}>
      {children}
    </StyledBox>
  );
};

Footer.displayName = 'Paper.Footer';

export default Footer;
